import * as pages from './pages';

export const fontScaleTextAreaProps = {
    // H1 Size
    maxFontSize: 96,
    // Subtitle1 Size
    minFontSize: 16,
    rowLimit: 4,
    style: `
        text-align: center;
    `
};
export const mobileFontScaleTextAreaProps = {
    // H1 Size
    maxFontSize: 40,
    // Subtitle1 Size
    minFontSize: 16,
    rowLimit: 2,
    style: `
        text-align: center;
    `
};

export const pageTitleBlockAspectRatio = 928 / 727;

export const defaultStyleSetting = {
    titleColor: '#ffffff',
    buttonTextColor: '#ffffff',
    buttonBgColor: '#D52222',
    contentBgColor: '#FF9901',
    bgColor: 'rgb(211, 243, 253)'
};

export const pageDefaultBackgroundImageSrc = {
    [pages.FAIL_PAGE]: 'https://assets.fevercdn.com/promotion/img/memoryMatch_failPage_bg.jpg',
    [pages.SUCCESS_PAGE]: 'https://assets.fevercdn.com/promotion/img/memoryMatch_successPage_bg.jpg'
};
